<template>
  <v-card class="elevation-12" :loading="loading">
    <v-toolbar
        color="primary"
        dark
        flat
    >
      <v-toolbar-title>{{ $t('editTemplateForm.title') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text class="my-5">
      <v-form>
        <v-text-field
            v-model="template.name"
            :label="$t('addTemplateForm.labels.name')"
            type="text"
            maxlength="400"
            :value="template.name"
            :error-messages="nameErrors"
        />

        <v-autocomplete v-model="template.organization"
                        :items="organizations"
                        :label="$t('addTemplateForm.labels.organization')"
                        :dense="true"
                        :clearable="true"
                        item-text="name"
                        item-value="id"
        />


        <v-file-input v-model="template.file"
                      :show-size="true"
                      :label="$t('addTemplateForm.labels.selectFile')"
                      accept=".html"
                      :error-messages="fileErrors"
        />

        <v-snackbar v-model="isServerError"
                    :timeout="5000"
                    :top="true"
                    color="error"
        >
          {{ $t('addTemplateForm.messages.serverError') }}
        </v-snackbar>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn text color="secondary" @click="onCancelButtonClicked">{{ $t('addTemplateForm.actions.cancel') }}</v-btn>
      <v-spacer/>
      <v-btn text color="primary" @click="onSaveButtonClicked">{{ $t('editTemplateForm.actions.save') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {maxLength, required} from "vuelidate/lib/validators";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import OrganizationService from "@/services/organization.service";
import _ from "underscore";
import Mappers from "@/mappers";
import AdminTemplateService from "@/services/admin.template.service";

export default {
  name: "EditAdminTemplateComponent",
  props: {
    inn: String
  },
  data() {
    return {
      loading: false,
      template: {
        Id: null,
        name: '',
        file: null,
        organization: null
      },
      organizations: [],
      isServerError: false,
    }
  },
  computed: {
    fileErrors() {
      const errors = []

      if (this.$v.template.file.$dirty) {
        if (!this.$v.template.file.required)
          errors.push(this.$t('addTemplateForm.errors.fileRequired'))
      }

      return errors
    },
    organizationErrors() {
      const errors = []

      if (this.$v.template.organization.$dirty)
        if (!this.$v.template.organization.required)
          errors.push(this.$t('addTemplateForm.errors.orgRequired'))

      return errors
    },
    nameErrors(){
      const errors = []

      if (this.$v.template.name.$dirty)
        if (!this.$v.template.name.required)
          errors.push(this.$t('addTemplateForm.errors.nameRequired'))

      return errors
    },
  },
  validations: {
    template: {
      name: {
        required,
        maxLength: maxLength(400)
      },
      organization: {
        required
      },
      file: {
        required
      }
    }
  },
  methods: {
    set(template) {
      this.clear();

      this.template = {
        ...this.template,
        Id: template.Id,
        name: template.Name,
        organization: template.Organization.id,
      };

      this.loadOrganizations();
    },
    clear() {
      this.$v.$reset()

      this.template.name = ''
      this.template.organization = null
      this.template.file = null
    },
    loadOrganizations() {
      this.$store.dispatch(LAYOUT_LOADING_START)

      OrganizationService.getOrganizations({})
          .then(response => {
            this.organizations = _.map(response.data.Records, o => {
              return Mappers.mapOrganization(o?.Organization)
            })
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    onCancelButtonClicked() {
      this.clear()
      this.$emit('cancel')
    },
    onSaveButtonClicked() {
      this.$v.template.$touch()
      if (!this.$v.template.$invalid) {
        this.loading = true;
        this.$store.dispatch(LAYOUT_LOADING_START)

        this.isServerError = false

        const reader = new FileReader();
        reader.onload = (event) => {
          let htmlContent = event.target.result;

          const utf8Bytes = new TextEncoder().encode(htmlContent);
          const charArray = Array.from(utf8Bytes);
          const charStringArray = charArray.map(charCode => String.fromCharCode(charCode));
          const base64Encoded = btoa(charStringArray.join(''));

          let templateData = {
            Id: this.template.Id,
            Name: this.template.name,
            OrganizationId: this.template.organization,
            Base64Content: base64Encoded
          };

          AdminTemplateService.putTemplate({templateData})
              .then(() => {
                this.clear()
                this.$emit('updated')
              }, () => {
                this.isServerError = true
              })
              .finally(() => {
                this.loading = false
                this.$store.dispatch(LAYOUT_LOADING_STOP)
              })
        };

        reader.onerror = (error) => {
          console.error('Error reading file:', error);
        };

        reader.onabort = () => {
          console.error('File reading aborted.');
        };

        reader.readAsText(this.template.file);
      }
    }
  }
}
</script>

<style scoped>

</style>